import React from 'react';

export function CircleIcon(): JSX.Element {
  return (
    <svg height='5' width='5' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='50' cy='50' r='40' stroke='black' strokeWidth='3' fill='black' />
    </svg>
  );
}
